import React, { useEffect, useState } from 'react';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import AdminMobileSearchInput from 'routes/adminMobile/components/common/AdminMobileSearchInput';
import AdminMobileStoreSearchList from 'routes/adminMobile/components/AdminMobileStoreSearchList';
import AdminMobileContentBox from '../components/common/AdminMobileContentBox';
// import { Map, MapMarker } from "react-kakao-maps-sdk";

// 가맹점 조회 테스트 데이터
import testStoreListLocationData from 'routes/adminMobile/commonVar/testStoreListLocationData';
// const testStoreListLocationData = [];

const  AdminMobileStoreSearch = () => {
    // 검색어 상태 추가
    const [searchKeyword, setSearchKeyword] = useState('');
    // 테스트 데이터 기준으로 토글 기능 구현
    const [storeList, setStoreList] = useState([...testStoreListLocationData]);
    
    // 검색 컴포넌트 기능
    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };
    // storeFav에 따라 리스트 분리 및 병합하는 함수
    const mergeListByStoreFav = (list) => {
        const trueFavItems = list.filter(item => item.storeFav);
        const falseFavItems = list.filter(item => !item.storeFav);
        return [...trueFavItems, ...falseFavItems];
    };
    // 검색 결과를 필터링하여 반환하는 함수
    const filterSaleListBySearch = () => {
        if (!searchKeyword) {
            // 검색어가 없으면 전체 목록 반환
            return mergeListByStoreFav(storeList);
        } else {
            // 검색어가 있는 경우 검색 결과를 반환
            const filteredList = storeList.filter(item => item.storeName.includes(searchKeyword));
            return mergeListByStoreFav(filteredList);
        }
    };
    // 검색 결과를 저장할 변수
    const filteredSaleList = filterSaleListBySearch();
    

    // 즐겨찾기 토글 함수
    const toggleFavorite = (index) => {
        const updatedFilteredSaleList = [...filteredSaleList]; // 검색된 결과를 변경 가능한 배열로 복사
        updatedFilteredSaleList[index].storeFav = !updatedFilteredSaleList[index].storeFav;
        
        // storeFav가 true인 항목들을 배열의 앞쪽으로 이동
        const sortedSaleList = updatedFilteredSaleList.sort((a, b) => {
            // a가 storeFav이면서 b가 storeFav가 아닌 경우 a를 앞으로
            if (a.storeFav && !b.storeFav) {
                return -1;
            }
            // b가 storeFav이면서 a가 storeFav가 아닌 경우 b를 앞으로
            else if (!a.storeFav && b.storeFav) {
                return 1;
            }
            // 나머지는 testStoreSaleData 배열의 순서를 따름
            else {
                return testStoreListLocationData.indexOf(a) - testStoreListLocationData.indexOf(b);
            }
        });

        // 중복 제거를 위한 Set을 사용하여 storeId 기준으로 중복 제거
        const uniqueSaleList = Array.from(new Set([...testStoreListLocationData, ...sortedSaleList]));

        // 정렬된 배열을 상태로 설정
        setStoreList(uniqueSaleList);
    };
    

    // 카카오 지도 맵 API 붙이기
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=262bef9b8074e21d9de587d3653da16b&libraries=services,clusterer";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // 컴포넌트가 unmount될 때 스크립트 제거
            document.body.removeChild(script);
        };
    }, []); // useEffect를 빈 배열을 전달하여 컴포넌트가 처음 마운트될 때만 실행

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>가맹점 조회</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색창 */}
                        <AdminMobileSearchInput placeholder="점포명을 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 카카오 지도 맵 */}
                        {/* https://react-kakao-maps-sdk.jaeseokim.dev/ */}
                        <AdminMobileContentBox>
                            <P>카카오 지도 API 붙일 예정</P>
                        </AdminMobileContentBox>
                    </FlexChild>
                    <FlexChild>
                        {/* 매장 리스트 출력 */}
                        <AdminMobileStoreSearchList stores={filteredSaleList} toggleFavorite={toggleFavorite} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </div>
    );
};

export default AdminMobileStoreSearch;